import { Component, Input, OnInit, OnChanges, ApplicationRef, Inject, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthenticationService } from './core/services/authentication.service';
import { GetQuoteDetailsService } from './core/services/get-quote-details.service';
import { GoogleAnalyticsEventsService } from './core/services/google-analytics-events.service';
import { SharedDataService } from './core/services/shared-data.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnChanges {
  title = 'RP INSURANCE WIDGET';
  isSessionAvailable;
  sessionWidgetData;
  paymentFrequencyInfo;
  receivedSettings = false;
  currDate;
  effectiveDateLimit;
  timezoneOffset;
  quoteRequestData;
  resetToken = false;
  sampleId = '0';

  refreshTokenListener: () => void;

  constructor(
    private renderer: Renderer2,
    private router: Router,
    public sanitizer: DomSanitizer,
    public SharedDataService: SharedDataService,
    private AuthenticationService: AuthenticationService,
    public GetQuoteDetailsService: GetQuoteDetailsService,
    private GoogleAnalyticsEventsService: GoogleAnalyticsEventsService,
    private appRef: ApplicationRef
  ) {
    if (!this.refreshTokenListener) {
      this.refreshTokenListener = renderer.listen('document', 'refreshToken', (event) => {
        console.log('LISTENER GETTING EVENT!');
        this.getNewToken(true);
      });
    }
  }

  trackInsuranceRedirect() {
    /** Google Analytics Event */
    this.SharedDataService.trackEvents(
      'Insurance Widget',
      'Redirect To CoverMyStuff',
      this.SharedDataService.data.insuranceInfo.quoteRequestSource
    );
  }

  packageResort(packages) {
    return packages;
  }

  getSettings(settingsData) {
    /** Make request to API service for Settings */
    console.log('GETTING SETTINGS');

    // Check Resident count & limit it to 5
    if (settingsData.residentsInfo.length > 5) {
      // Reverse the order of the residents so we can splice them in the order prvided by the parent application.
      settingsData.residentsInfo.reverse();
      let count = 0;
      for (let i = settingsData.residentsInfo.length - 1; i >= 0; i--) {
        if (!settingsData.residentsInfo[i].isPrimaryResident) {
          if (count < 4) {
            count++;
          } else {
            settingsData.residentsInfo.splice(i, 1);
          }
        }
      }
    }

    /** Save settings data if need for additional maintenance calls */
    this.SharedDataService.data.settingsData = settingsData;

    this.GetQuoteDetailsService.getWidgetSettings(settingsData).subscribe(
      (data) => {
        this.receivedSettings = true;
        console.log('DATA RESPONSE: ', data);

        /** SET insurance required setting */
        if (data.isRequired) {
          this.SharedDataService.data.insuranceRequired = true;
        }
        if (!this.SharedDataService.data.insuranceRequired) {
          this.SharedDataService.trackEvents(
            'Insurance Widget',
            'User - Non-Required',
            this.SharedDataService.data.insuranceInfo.quoteRequestSource
          );
        }
        /** END SET insurance required setting */

        /** SET decline insurance setting */
        if (!data.DeclineInfo.enable) {
          this.SharedDataService.data.allowDeclineInsurance = false;
        }
        /** END SET decline insurance setting */

        /** SET IP flag */
        this.SharedDataService.data.ipEnabled = false;
        if (data.isIPEnabled) {
          this.SharedDataService.data.ipEnabled = true;
        }

        /** SET PV flag */
        this.SharedDataService.data.isPVEnabled = false;
        if (data.isPVEnabled) {
          this.SharedDataService.data.isPVEnabled = true;
        }

        /** END SET ip flag */

        /** SET third party policy setting */
        if (!data.ThirdPartyInfo.enable) {
          this.SharedDataService.data.allowThirdParty = false;
        }
        /** END SET third party policy setting */

        /** Set property liability limit  */
        if (data.propLiabilityLimit) {
          this.SharedDataService.data.propLiabilityLimit = data.propLiabilityLimit;
        }
        /** END Set property liability limit  */

        /** Hardcode the point of lease until API service is ready */

        /** IF point of lease is activated in settings */
        if (data.POLInfo.enable) {
          this.SharedDataService.data.pointOfLease = {
            flow: 'multiOption',
            quoteID: data.POLInfo.quoteID,
            polRateDetails: data.POLInfo.polRateDetails,
            type: 'eRenterDirect',
          };
        } else if (data.assetProtectInfo.enable) {
          /** Begin AssetProtect is activated in settings */
          this.SharedDataService.data.pointOfLease = {
            flow: 'multiOption',
            quoteID: 0,
            propertyID: 0,
            addendumTemplate: '',
            polRateDetails: [],
            type: 'assetProtect',
          };
          /** END AssetProtect is activated in settings */
        } else if (this.sessionWidgetData.appSource === 'Policy Validator' && this.SharedDataService.data.allowThirdParty) {
          /** Begin Policy Validator */
          this.SharedDataService.data.pointOfLease = {
            flow: 'multiOption',
            quoteID: 0,
            propertyID: 0,
            addendumTemplate: '',
            polRateDetails: [],
            type: 'policyValidator',
          };
          /** End Policy Validator */
        } else {
          this.SharedDataService.data.pointOfLease.flow = 'inactive';
        }
        /** END IF point of lease is activated in settings */

        /** IF property is Carrier integrated */
        if (data.isCarrierAPIIntegrated && this.SharedDataService.data.insuranceInfo && this.quoteRequestData) {
          this.SharedDataService.data.insuranceInfo.isCarrierAPIIntegrated = true;
          this.quoteRequestData.isCarrierAPIIntegrated = true;
        }
        /** END property is Carrier integrated */

        /** IF active AB Tests in settings */
        if (data.aBTestData && data.aBTestData.testCases) {
          for (let i = 0; i < data.aBTestData.testCases.length; i++) {
            const singleTest = data.aBTestData.testCases[i];
            if (singleTest.source === 'widget' && singleTest.testEnabled) {
              const randomNum = Math.floor(Math.random() * 100) + 1;
              console.log('RANDOM NUMBER: ', randomNum);
              if (randomNum <= singleTest.percentage) {
                this.SharedDataService.data.aBTests[singleTest.testName] = {
                  id: singleTest.abTestID,
                  name: singleTest.testName,
                  viewed: false,
                };
                console.log('ADDED TEST: ', this.SharedDataService.data.aBTests);
              } else {
                console.log('EXCLUDED TEST: ', singleTest);
              }
            }
          }
        }
        /** END IF active AB Tests in settings */
        if (!this.SharedDataService.data.requestedQuote && data.HO4Info.enable && !this.SharedDataService.data.retrieveQuoteID) {
          /** Create HO4 Quote for preparation of eRenterPlan */
          this.getQuoteData(this.quoteRequestData);
        } else {
          this.router.navigate(['/control-flow'], { skipLocationChange: true });
        }
        if (data.paymentMaintenance) {
          this.SharedDataService.data.paymentMaintenance = data.paymentMaintenance;
        }
        this.SharedDataService.data.isSMSEnabled = data.isSMSEnabled;
        this.SharedDataService.data.isIPEnabled = data.isIPEnabled;
      },
      (err) => {
        this.receivedSettings = false;
        const errDetail = this.GetQuoteDetailsService.processErrorDetails(err);
        for (let i = 0; i < errDetail.length; i++) {
          const detail = errDetail[i];
          console.log('ERROR DETAIL: ', detail);
        }

        // Show Error Screen
        this.SharedDataService.data.requestedQuote = true;
        this.SharedDataService.data.receivedQuote = false;
        this.SharedDataService.data.pointOfLease.flow = 'inactive';
        this.router.navigate(['/control-flow'], { skipLocationChange: true });

        /** Fire event to tell parent application about declined insurance */
        this.GetQuoteDetailsService.dispatchEvents(window.top.document, 'declineInsurance', 0);
        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance Widget',
          'Error Loading Settings',
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
      }
    );
  }

  setUpQuoteData(data) {
    this.SharedDataService.data.productPackageInfo = this.packageResort(data.productPackageInfo);
    /** Setup default package selections if coming from a retrieved quote */
    for (let i = 0; i < data.productPackageInfo.length; i++) {
      console.log('=====Comparing Product Packages.=====');
      const packageItem = this.SharedDataService.data.productPackageInfo[i];
      if (packageItem.productInfo[0].defaultOption) {
        console.log('Found Default Selected Product Package.');
        this.SharedDataService.data.insuranceInfo.productGroupID = packageItem.productGroupID;

        if (this.sessionWidgetData.quoteID) {
          this.SharedDataService.data.userActions.retrieveQuote = [];
          this.SharedDataService.data.userActions.retrieveQuote.initialPackageID = packageItem.productGroupID;
        }

        for (let j = 0; j < packageItem.deductibleInfo.length; j++) {
          const deductibleItem = packageItem.deductibleInfo[j];
          if (deductibleItem.defaultOption) {
            console.log('Found Default Selected Deductible.');
            this.SharedDataService.data.insuranceInfo.selectedOptions.deductibleInfo = this.SharedDataService.pullPackageCarrierData(
              deductibleItem
            );
          }
        }
      }
    }
    this.SharedDataService.data.underwritingInfo = data.underwritingQuestions;
    /** Remove Security Questions Panel if no questions exist */
    if (!this.SharedDataService.data.underwritingInfo || this.SharedDataService.data.underwritingInfo.length === 0) {
      this.SharedDataService.removeStep('insuranceScreening');
    } else {
      this.GetQuoteDetailsService.dispatchEvents(window.top.document, 'stepTracker', '+insuranceScreening');
    }
    /** Pull the coverage start date and run it through validation */
    if (data.coverageEffDate) {
      this.validateCoverageDate(data.coverageEffDate);
    }
    /** Pull residentInfo and push it into the SharedDataService */
    if (data.residentInfo) {
      this.validateResidentData(data.residentInfo);
    }
    /** Pull ABtest data (if it exists) */
    if (data.abTests && data.abTests.length > 0) {
      for (let i = 0; i < data.abTests.length; i++) {
        const singleTest = data.abTests[i];
        this.SharedDataService.data.aBTests[singleTest.testName] = {
          id: singleTest.abTestID,
          name: singleTest.testName,
          viewed: true,
        };
        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance API - GetQuote',
          singleTest.testName,
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
        console.log('ADDED TEST: ', this.SharedDataService.data.aBTests);
      }
    }

    /** Pull UnitInfo and push it into the SharedDataService */
    if (data.unitInfo) {
      this.SharedDataService.data.sessionUnitInfo = {
        idSource: 'LeasingDesk',
        propertyID: data.propertyInfo.propertyId,
        unitID: data.unitInfo.UnitID,
      };
    }

    this.SharedDataService.data.insuranceInfo.quoteID = data.quoteID;
    this.SharedDataService.data.insuranceInfo.isCarrierAPIToggle = data.isCarrierAPIToggle;
    this.SharedDataService.data.modalFeeInfo = data.modalFeeInfo;
    this.SharedDataService.data.checkProcessingFeeInfo = data.checkProcessingFee;
    this.SharedDataService.data.termFeeInfo = {
      description: data.termFee.feeDescription,
      premium: data.termFee.feeAmount,
    };
    if (this.SharedDataService.isLDAppSource()) {
      this.SharedDataService.data.insuranceInfo.agentUserID = data.agentUserID;
    }
    if (data.paperlessInfo) {
      console.log('PAPERLESS INFO: ', data.paperlessInfo);
      this.SharedDataService.data.paperlessInfo = {
        termsAndCondition: data.paperlessInfo.paperlessTermsConditionsText,
        paperlessEnabled: data.paperlessInfo.isPaperlessEnabled,
      };
    }
    if (data.taxInfo && data.taxInfo.length > 0) {
      this.SharedDataService.data.insuranceInfo.selectedOptions.taxInfo = data.taxInfo;
    }
    if (data.specialInfo && data.specialInfo.length > 0) {
      this.SharedDataService.data.insuranceInfo.selectedOptions.specialInfo = data.specialInfo;
    } else {
      this.SharedDataService.data.insuranceInfo.selectedOptions.specialInfo = [];
    }
    this.paymentFrequencyInfo = data.productPaymentFrequency;
    this.SharedDataService.data.paymentNotices = {
      policyNotice: data.policyNotice,
      termsAndCondition: data.termsAndCondition,
      noticeOfPrivacyPolicyPractice: data.noticeofPrivacyPolicyPractice,
      noticeOfFraudWarning: data.noticeofFraudWarning,
      acknowledgeMessage: data.acknowledgeMessage,
    };
    this.SharedDataService.data.insuranceCarrierInfo = {
      carrierAddress: data.carrierAddress,
      carrierCode: data.carrierCode,
      carrierName: data.carrierName,
      underWriterName: data.underWriterName,
      naicLicense: data.naicLicense,
      agentLicense: data.agentLicense,
    };
    this.SharedDataService.data.propertyInfo = data.propertyInfo;
    console.log('PROPERTY INFO: ', this.SharedDataService.data.propertyInfo);
    this.SharedDataService.data.receivedQuote = true;
    if (this.sessionWidgetData.policyID) {
      this.SharedDataService.data.paymentFrequency = data.paymentFrequency;
    }

    /** Make sure Model processed before scrolling to the top of the next panel */
    this.appRef.tick();

    if (this.sessionWidgetData.quoteID && data.unitInfo) {
      /** Populate the Quote Request Data Object*/
      this.quoteRequestData = {
        authInfo: {
          userId: 'webservice@realpage.com',
          password: 'hgC2HfBd',
        },
        propertyInfo: {
          propertyIDType: 'LeasingDesk',
          propertyID: data.propertyInfo.propertyId,
        },
        unitInfo: {
          unitIDType: 'LeasingDesk',
          unitID: data.unitInfo.UnitID,
        },
        coverageDate:
          this.SharedDataService.data.coverageDate.getFullYear() +
          '/' +
          (this.SharedDataService.data.coverageDate.getMonth() + 1) +
          '/' +
          this.SharedDataService.data.coverageDate.getDate(),
        quoteRequestSource: this.sessionWidgetData.appSource,
        isRenewal: false,
        residentsInfo: this.SharedDataService.data.sessionResidentInfo,
      };

      // Populate the unit ID if it exists
      if (this.SharedDataService.data.sessionUnitInfo.UnitID && this.SharedDataService.data.sessionUnitInfo.UnitID !== null) {
        /** Address inconsistency in the naming of unitID */
        this.quoteRequestData.unitInfo.unitID = this.SharedDataService.data.sessionUnitInfo.UnitID;
      }

      // Populate the isRenewal if it exists
      if (this.sessionWidgetData.isRenewal) {
        this.quoteRequestData.isRenewal = this.sessionWidgetData.isRenewal;
      }

      /** Get Widget Settings */
      this.getSettings(this.quoteRequestData);
    } else if (this.SharedDataService.data.pointOfLease.type === 'assetProtect') {
      this.getAssetProtectQuote(this.quoteRequestData);
    } else {
      if (this.sessionWidgetData.policyID) {
        this.router.navigate(['/coverage-changes-flow'], { skipLocationChange: true });
      } else {
        this.router.navigate(['/control-flow'], { skipLocationChange: true });
      }
    }
  }

  getAssetProtectQuote(quoteData) {
    /** Google Analytics Event */
    this.SharedDataService.trackEvents(
      'Insurance Widget',
      'Attempt Asset Protect Quote Retrieval',
      this.SharedDataService.data.insuranceInfo.quoteRequestSource
    );
    this.GetQuoteDetailsService.getMasterPolicyQuote(quoteData).subscribe(
      (data) => {
        console.log('ASSET PROTECT QUOTE INFO RESPONSE: ', data);

        /** Populate the Asset Protect Quote Data */
        this.SharedDataService.data.pointOfLease.quoteID = data.quoteId;
        this.SharedDataService.data.pointOfLease.propertyID = data.ldPropertyID;
        this.SharedDataService.data.pointOfLease.addendumTemplate = data.addendumTemplate;
        this.SharedDataService.data.pointOfLease.polRateDetails = data.productPackageInfo;

        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance Widget',
          'Success Asset Protect Quote Retrieval',
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
        this.router.navigate(['/control-flow'], { skipLocationChange: true });
      },
      (err) => {
        console.log('ERROR RESPONSE: ', err);
        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance Widget',
          'Error Asset Protect Quote Retrieval',
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
        console.log('Error occured: ', err.error.detail);
        this.SharedDataService.data.pointOfLease.flow = 'inactive';
        this.router.navigate(['/control-flow'], { skipLocationChange: true });
      }
    );
  }

  getQuoteByID(quoteID) {
    this.SharedDataService.data.requestedQuote = true;
    /** Check for Quote ID */
    this.GetQuoteDetailsService.getQuoteByID(quoteID, this.SharedDataService.data.insuranceInfo.quoteRequestSource).subscribe(
      (data) => {
        console.log('QUOTE INFO RESPONSE: ', data);
        /** Populate the Quote Data */
        this.setUpQuoteData(data);

        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance Widget',
          'Success Quote Retrieval',
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
      },
      (err) => {
        this.SharedDataService.data.receivedQuote = false;
        if (this.SharedDataService.data.insuranceInfo.quoteRequestSource === 'LeasingDesk Call Center') {
          this.SharedDataService.data.retrieveQuoteLDError = true;
        } else {
          this.SharedDataService.data.pointOfLease.flow = 'inactive';
        }

        const errDetail = this.GetQuoteDetailsService.processErrorDetails(err);
        for (let i = 0; i < errDetail.length; i++) {
          const detail = errDetail[i];
          console.log('ERROR DETAIL: ', detail);
        }
        /** Fire event to tell parent application about declined insurance */
        this.GetQuoteDetailsService.dispatchEvents(window.top.document, 'declineInsurance', 0);
        /** Google Analytics Event */
        if (!this.SharedDataService.data.insuranceRequired) {
          this.SharedDataService.trackEvents(
            'Insurance Widget',
            'Error Quote Retrieval - Non-Required',
            this.SharedDataService.data.insuranceInfo.quoteRequestSource
          );
        } else {
          this.SharedDataService.trackEvents(
            'Insurance Widget',
            'Error Quote Retrieval',
            this.SharedDataService.data.insuranceInfo.quoteRequestSource
          );
        }
        console.log('Error occured: ', err.error.detail);
        this.router.navigate(['/control-flow'], { skipLocationChange: true });
      }
    );
  }

  getQuoteData(startupInfo: object) {
    this.SharedDataService.data.requestedQuote = true;
    this.GetQuoteDetailsService.getQuote(startupInfo).subscribe(
      (data) => {
        console.log('QUOTE INFO RESPONSE: ', data);
        this.setUpQuoteData(data);
        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance Widget',
          'Success Quote Retrieval',
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
      },
      (err) => {
        this.SharedDataService.data.receivedQuote = false;
        const errDetail = this.GetQuoteDetailsService.processErrorDetails(err);
        for (let i = 0; i < errDetail.length; i++) {
          const detail = errDetail[i];
          console.log('ERROR DETAIL: ', detail);
          if (detail.indexOf('Due to your lease starting more than') !== -1) {
            console.log('Quote Coverage Date Out Of Limit');
            this.SharedDataService.data.beyondEffectiveDate = true;
            this.SharedDataService.data.customErrorMessage = detail;
          } else if (detail.indexOf('We cannot process policy requests online at this time') !== -1) {
            this.SharedDataService.data.propertyMoratorium = true;
            this.SharedDataService.data.customErrorMessage = detail;
          }
        }
        /** Fire event to tell parent application about declined insurance */
        this.GetQuoteDetailsService.dispatchEvents(window.top.document, 'declineInsurance', 0);
        /** Google Analytics Event */
        if (!this.SharedDataService.data.insuranceRequired) {
          this.SharedDataService.trackEvents(
            'Insurance Widget',
            'Error Quote Retrieval - Non-Required',
            this.SharedDataService.data.insuranceInfo.quoteRequestSource
          );
        } else {
          this.SharedDataService.trackEvents(
            'Insurance Widget',
            'Error Quote Retrieval',
            this.SharedDataService.data.insuranceInfo.quoteRequestSource
          );
        }

        console.log('Error occured: ', err.error.detail);
        this.router.navigate(['/control-flow'], { skipLocationChange: true });
      }
    );
  }
  getPolicyCoverageDetailsByID(policyID) {
    this.GetQuoteDetailsService.getPolicyCoverageDetails(policyID, this.SharedDataService.data.insuranceInfo.quoteRequestSource).subscribe(
      (data) => {
        console.log('Policy Coverage  INFO RESPONSE: ', data);
        /** Populate the Quote Data */
        this.setUpQuoteData(data);
        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance Widget',
          'Success Policy Coverage Details',
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
        this.SharedDataService.data.getpolicyCoverageDetails = data;
        this.SharedDataService.data.policyCoverageError = false;
      },
      (err) => {
        this.SharedDataService.data.policyCoverageError = true;
        const errDetail = this.GetQuoteDetailsService.processErrorDetails(err);
        for (let i = 0; i < errDetail.length; i++) {
          const detail = errDetail[i];
          console.log('ERROR DETAIL: ', detail);
        }
        this.router.navigate(['/coverage-changes-flow'], { skipLocationChange: true });
        console.log('Error occured: ', err.error.detail);
      }
    );
  }
  hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  validateColorFormats(themeData) {
    if (themeData.primaryColor && themeData.primaryColor.indexOf('rgb(') === -1 && themeData.primaryColor.indexOf('#') === -1) {
      themeData.primaryColor = '#4d9eec';
    }
    if (themeData.backgroundColor && themeData.backgroundColor.indexOf('rgb(') === -1 && themeData.backgroundColor.indexOf('#') === -1) {
      themeData.backgroundColor = '#FFFFFF';
    }
    if (themeData.secondaryColor && themeData.secondaryColor.indexOf('rgb(') === -1 && themeData.secondaryColor.indexOf('#') === -1) {
      themeData.secondaryColor = '#ee6300';
    }
    this.loadCSS(themeData);
  }

  loadCSS(themeData) {
    console.log(themeData);
    // Apply Custom CSS Variables
    let customCSS = '';
    if (themeData.borderRadius) {
      customCSS += ' --rp-border-radius: ' + themeData.borderRadius + '; ';
    }
    if (themeData.primaryColor) {
      customCSS += ' --rp-primary-color: ' + themeData.primaryColor + '; ';
      if (themeData.primaryColor.indexOf('rgb(') !== -1) {
        const primaryRGB = themeData.primaryColor.match(/\d+/g);
        console.log('splitting out the RGB: ', primaryRGB);
        customCSS += ' --rp-primary-color-rgb: ' + primaryRGB[0] + ',' + primaryRGB[1] + ',' + primaryRGB[2] + '; ';
      } else {
        const primaryHex = this.hexToRgb(themeData.primaryColor);
        customCSS += ' --rp-primary-color-rgb: ' + primaryHex.r + ',' + primaryHex.g + ',' + primaryHex.b + '; ';
      }
    }
    if (themeData.backgroundColor) {
      customCSS += ' --rp-background-color: ' + themeData.backgroundColor + '; ';
    }
    if (themeData.secondaryColor) {
      customCSS += ' --rp-secondary-color: ' + themeData.secondaryColor + '; ';
    }

    document.querySelector('body').style.cssText = customCSS;
  }

  loadGA(userId) {
    if (!environment.googleAnalyticsID && !environment.googleTagManagerID) {
      return;
    } else {
      if (environment.googleAnalyticsID) {
        const scriptId = 'google-analytics';
        if (document.getElementById(scriptId)) {
          return;
        }
        const s = document.createElement('script') as any;
        s.type = 'text/javascript';
        s.id = scriptId;
        s.innerText =
          '(function(i,s,o,g,r,a,m){i["GoogleAnalyticsObject"]=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,"script","//www.google-analytics.com/analytics.js","ga");ga("create", { trackingId: "' +
          environment.googleAnalyticsID +
          '", cookieDomain: "auto", userId: "' +
          userId +
          '"});';
        document.getElementsByTagName('head')[0].appendChild(s);
      }

      if (environment.googleTagManagerID) {
        if (document.getElementById('gtm1')) {
          return;
        }

        // Create DataLayer Object
        const gtmDataLayer = document.createElement('script') as any;
        gtmDataLayer.type = 'text/javascript';
        gtmDataLayer.id = 'gtmDataLayer';
        gtmDataLayer.innerText = 'window.dataLayer = window.dataLayer || [];';
        document.getElementsByTagName('head')[0].appendChild(gtmDataLayer);

        // Load the Google Tag Manager First Script
        const gtm1 = document.createElement('script') as any;
        gtm1.type = 'text/javascript';
        gtm1.id = 'gtm1';
        gtm1.src = 'https://www.googletagmanager.com/gtm.js?id=' + environment.googleTagManagerID;
        document.getElementsByTagName('head')[0].appendChild(gtm1);

        // Load the Google Tag Manager Second Script
        const gtm2 = document.createElement('script') as any;
        gtm2.type = 'text/javascript';
        gtm2.id = 'gtm2';
        gtm2.innerText =
          `(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'}); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);}) (window, document, 'script', 'dataLayer', '` +
          environment.googleTagManagerID +
          `');`;
        document.getElementsByTagName('head')[0].appendChild(gtm2);
      }
    }
  }

  getGoogleTagManagerURL(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.googletagmanager.com/ns.html?id=${environment.googleTagManagerID}`);
  }

  getAnalyticsToken(validation) {
    const AnalyticsData = { analyticsCode: validation };
    console.log('Using the Code: ', AnalyticsData);
    this.AuthenticationService.getAnalyticsToken(AnalyticsData).subscribe(
      (data) => {
        /** Refresh the Auth Token */
        this.GetQuoteDetailsService.setToken('api', data.token);
        console.log('setting Token: ', data.token);
        if (this.SharedDataService.data.resetToken || (this.receivedSettings && this.SharedDataService.data.currentStep > 0)) {
          /** Fire event to notify function token is valid */
          this.GetQuoteDetailsService.dispatchEvents(document, 'tokenRefreshed', 0);
          this.SharedDataService.data.resetToken = false;
        } else {
          if (this.sessionWidgetData.quoteID) {
            this.getQuoteByID(this.sessionWidgetData.quoteID);
          } else if (this.sessionWidgetData.policyID) {
            this.SharedDataService.data.userToken = this.sessionWidgetData.userToken;
            this.getPolicyCoverageDetailsByID(this.sessionWidgetData.policyID);
          } else {
            /** Get Settings Data */
            this.getSettings(this.quoteRequestData);
          }
        }
        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance Widget',
          'Auth Token Retrieved',
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
      },
      (err) => {
        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance Widget',
          'Error Getting Auth Token',
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
      }
    );
  }

  getNewToken(resetEvent: boolean): void {
    this.SharedDataService.data.resetToken = resetEvent;
    console.log('GETTING NEW TOKEN: ', this.SharedDataService.data.resetToken);
    this.getValidation();
  }

  validateCoverageDate(coverageDate) {
    /** Removing unnecessary date/time formatting */
    const dateSplit = coverageDate.split('T', 1);
    console.log('DATE SPLIT: ', dateSplit);
    if (dateSplit.length && dateSplit[0] != '') {
      coverageDate = dateSplit[0];
      console.log('DATE SPLIT CONVERTED: ', coverageDate);
    }
    this.sessionWidgetData.coverageEffDate = coverageDate.replace(/-/g, '/');
    this.SharedDataService.data.coverageDate = new Date(this.sessionWidgetData.coverageEffDate);
    console.log('COVERAGE DATE: ', this.SharedDataService.data.coverageDate);
    this.timezoneOffset = this.currDate.getTimezoneOffset() - 300;
    console.log('CURRENT DATE: ', this.currDate);
    console.log('CURRENT DATE TIMEZONE OFFSET: ', this.currDate.getTimezoneOffset());

    if (this.timezoneOffset > 0) {
      this.currDate = new Date(+this.currDate + this.timezoneOffset * 60000);
      console.log('CURRENT DATE UPDATED: ', this.currDate);
    }

    if (+this.currDate > +this.SharedDataService.data.coverageDate && !this.SharedDataService.isLDAppSource()) {
      console.log('UPDATED PAST COVERAGE DATE TO TODAY.');
      this.SharedDataService.data.coverageDate = this.currDate;
    }

    if (+this.currDate.setHours(0, 0, 0, 0) == +this.SharedDataService.data.coverageDate.setHours(0, 0, 0, 0)) {
      console.log('Effective Date Is Today!');
      this.SharedDataService.data.effectiveDateIsToday = true;
    }
  }

  validateResidentData(residentData) {
    this.SharedDataService.data.sessionResidentInfo = residentData;
    console.log('SESSION RESIDENT INFO: ', this.SharedDataService.data.sessionResidentInfo);

    for (let i = 0; i < this.SharedDataService.data.sessionResidentInfo.length; i++) {
      // Remove the accents and other special characters out of the names.
      const str = 'ÁÉÍÓÚáéíóúâêîôûàèìòùÇç/~!@#$%&_';

      // Checking if middle name is null and setting it to an empty string so length checks can be done.
      if (
        !this.SharedDataService.data.sessionResidentInfo[i].resident.middleName ||
        this.SharedDataService.data.sessionResidentInfo[i].resident.middleName === null
      ) {
        this.SharedDataService.data.sessionResidentInfo[i].resident.middleName = '';
      }

      if (!this.SharedDataService.validateName(this.SharedDataService.data.sessionResidentInfo[i].resident.firstName)) {
        const firstName = this.SharedDataService.data.sessionResidentInfo[i].resident.firstName;
        this.SharedDataService.data.sessionResidentInfo[i].resident.firstName = firstName
          .normalize('NFD')
          .replace(/([\u0300-\u036f]|[^a-zA-Z\s])/g, '');
      }

      if (
        this.SharedDataService.data.sessionResidentInfo[i].resident.middleName &&
        !this.SharedDataService.validateName(this.SharedDataService.data.sessionResidentInfo[i].resident.middleName)
      ) {
        const middleName = this.SharedDataService.data.sessionResidentInfo[i].resident.middleName;
        this.SharedDataService.data.sessionResidentInfo[i].resident.middleName = middleName
          .normalize('NFD')
          .replace(/([\u0300-\u036f]|[^a-zA-Z\s])/g, '');
      }

      if (!this.SharedDataService.validateName(this.SharedDataService.data.sessionResidentInfo[i].resident.lastName)) {
        const lastName = this.SharedDataService.data.sessionResidentInfo[i].resident.lastName;
        this.SharedDataService.data.sessionResidentInfo[i].resident.lastName = lastName
          .normalize('NFD')
          .replace(/([\u0300-\u036f]|[^a-zA-Z\s])/g, '');
      }

      if (this.SharedDataService.data.sessionResidentInfo[i].resident.middleName.length > 20) {
        const middleName = this.SharedDataService.data.sessionResidentInfo[i].resident.middleName;
        const lastName = this.SharedDataService.data.sessionResidentInfo[i].resident.lastName;
        const initialCharacterString = middleName.match(/.{1,20}(\s|$)/g)[0];
        this.SharedDataService.data.sessionResidentInfo[i].resident.lastName =
          middleName.replace(initialCharacterString, '').trim() + ' ' + lastName.trim();
        this.SharedDataService.data.sessionResidentInfo[i].resident.middleName = initialCharacterString.trim();
      }

      if (this.SharedDataService.data.sessionResidentInfo[i].resident.lastName.length > 30) {
        const lastName = this.SharedDataService.data.sessionResidentInfo[i].resident.lastName.split('').reverse().join('');
        const middleName = this.SharedDataService.data.sessionResidentInfo[i].resident.middleName;
        const lastCharacterString = lastName.match(/.{1,30}(\s|$)/g)[0];
        this.SharedDataService.data.sessionResidentInfo[i].resident.middleName =
          middleName.trim() + ' ' + lastName.replace(lastCharacterString, '').split('').reverse().join('').trim();
        if (this.SharedDataService.data.sessionResidentInfo[i].resident.middleName.length > 20) {
          const middleNameTooLong = this.SharedDataService.data.sessionResidentInfo[i].resident.middleName.split('').reverse().join('');
          const firstName = this.SharedDataService.data.sessionResidentInfo[i].resident.firstName;
          const middleCharacterString = middleNameTooLong.match(/.{1,20}(\s|$)/g)[0];
          if (this.SharedDataService.data.sessionResidentInfo[i].resident.firstName.length + middleNameTooLong.length < 30) {
            this.SharedDataService.data.sessionResidentInfo[i].resident.firstName =
              firstName.trim() + ' ' + middleNameTooLong.replace(middleCharacterString, '').split('').reverse().join('').trim();
          }
          this.SharedDataService.data.sessionResidentInfo[i].resident.middleName = middleCharacterString
            .split('')
            .reverse()
            .join('')
            .trim();
        }
        this.SharedDataService.data.sessionResidentInfo[i].resident.lastName = lastCharacterString.split('').reverse().join('').trim();
        console.log('first name: ', this.SharedDataService.data.sessionResidentInfo[i].resident.firstName);
        console.log('middle name: ', this.SharedDataService.data.sessionResidentInfo[i].resident.middleName);
        console.log('last name: ', this.SharedDataService.data.sessionResidentInfo[i].resident.lastName);
      }

      if (this.SharedDataService.data.sessionResidentInfo[i].resident.firstName.length > 30) {
        const firstName = this.SharedDataService.data.sessionResidentInfo[i].resident.firstName;
        const middleName = this.SharedDataService.data.sessionResidentInfo[i].resident.middleName;
        const initialCharacterString = firstName.match(/.{1,30}(\s|$)/g)[0];
        this.SharedDataService.data.sessionResidentInfo[i].resident.middleName =
          firstName.replace(initialCharacterString, '').trim() + ' ' + middleName.trim();
        if (this.SharedDataService.data.sessionResidentInfo[i].resident.middleName.length > 20) {
          const middleNameTooLong = this.SharedDataService.data.sessionResidentInfo[i].resident.middleName;
          const lastName = this.SharedDataService.data.sessionResidentInfo[i].resident.lastName;
          const initialMiddleCharacterString = middleNameTooLong.match(/.{1,20}(\s|$)/g)[0];
          this.SharedDataService.data.sessionResidentInfo[i].resident.middleName = initialMiddleCharacterString.trim();
          if (this.SharedDataService.data.sessionResidentInfo[i].resident.lastName.length + middleNameTooLong.length < 30) {
            this.SharedDataService.data.sessionResidentInfo[i].resident.lastName =
              middleNameTooLong.replace(initialMiddleCharacterString, '').trim() + ' ' + lastName.trim();
          }
        }
        this.SharedDataService.data.sessionResidentInfo[i].resident.firstName = initialCharacterString.trim();
      }

      // Checking if first name is empty
      if (
        !this.SharedDataService.data.sessionResidentInfo[i].resident.firstName ||
        this.SharedDataService.data.sessionResidentInfo[i].resident.firstName === ''
      ) {
        this.SharedDataService.data.sessionResidentInfo[i].resident.firstName = 'NA';
      }

      // Checking if last name is empty
      if (
        !this.SharedDataService.data.sessionResidentInfo[i].resident.lastName ||
        this.SharedDataService.data.sessionResidentInfo[i].resident.lastName === ''
      ) {
        this.SharedDataService.data.sessionResidentInfo[i].resident.lastName = 'NA';
      }

      if (
        typeof this.SharedDataService.data.sessionResidentInfo[i].email === 'undefined' ||
        this.SharedDataService.data.sessionResidentInfo[i].email === null ||
        !this.SharedDataService.validateEmail(this.SharedDataService.data.sessionResidentInfo[i].email)
      ) {
        this.SharedDataService.data.sessionResidentInfo[i].email = '';
      }
      if (
        typeof this.SharedDataService.data.sessionResidentInfo[i].mobileNumber === 'undefined' ||
        this.SharedDataService.data.sessionResidentInfo[i].mobileNumber === null
      ) {
        this.SharedDataService.data.sessionResidentInfo[i].mobileNumber = '';
      } else {
        this.SharedDataService.data.sessionResidentInfo[i].mobileNumber = this.SharedDataService.data.sessionResidentInfo[
          i
        ].mobileNumber.replace(/[^0-9]/g, '');
      }

      if (
        (typeof this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth === 'undefined' ||
          this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth === null) &&
        this.SharedDataService.data.sessionResidentInfo[i].dateofBirth
      ) {
        console.log('DATE OF BIRTH USING OLD FORMAT : dateofBirth.');
        this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth = this.SharedDataService.data.sessionResidentInfo[i].dateofBirth;
      } else if (
        (typeof this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth === 'undefined' ||
          this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth === null) &&
        !this.SharedDataService.data.sessionResidentInfo[i].dateofBirth
      ) {
        console.log('DATE OF BIRTH IS NULL OR UNDEFINED.');
        this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth = '';
      }

      // Removing unnecessary date/time formatting
      const dateSplit = this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth.toString().split('T', 1);
      console.log('DATE SPLIT: ', dateSplit);
      if (dateSplit.length && dateSplit[0] !== '') {
        // Replace the dashes with slashes to address DOB value variations
        dateSplit[0] = dateSplit[0].replace(/-/g, '/');
        this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth = dateSplit[0];
        console.log('DATE SPLIT CONVERTED: ', this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth);
      }

      let dateCheck;
      // Creating current date to identify minimum DOB
      const currDate = new Date();
      currDate.setHours(0, 0, 0, 0);
      // Creating the min age limit on the DOB
      const minAgeDate = new Date();
      minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
      console.log('MIN AGE VALUE: ', minAgeDate.getTime());
      // Creating the max age limit on the DOB
      const maxAgeDate = new Date('January 1, 1900');
      console.log('MAX AGE VALUE: ', maxAgeDate.getTime());
      // Date of Birth Validation Before Getting Settings
      dateCheck = new Date(this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth).getTime();
      console.log('DATECHECK VALUE: ', dateCheck);

      if (dateCheck > minAgeDate.getTime() || dateCheck < maxAgeDate.getTime() || isNaN(dateCheck)) {
        console.log('DATE OF BIRTH IS INVALID.');
        this.SharedDataService.data.sessionResidentInfo[i].dateOfBirth = '';
      }

      if (this.SharedDataService.data.sessionResidentInfo[i].isPrimaryResident) {
        this.SharedDataService.data.sessionPrimaryResidentInfo = this.SharedDataService.data.sessionResidentInfo[i];

        /** Setup Google Analytics with Resident ID */
        this.loadGA(this.SharedDataService.data.sessionResidentInfo[i].externalResID);
      }
    }

    if (!this.sessionWidgetData.quoteID && !this.sessionWidgetData.policyID) {
      this.quoteRequestData = {
        authInfo: {
          userId: 'webservice@realpage.com',
          password: 'hgC2HfBd',
        },
        propertyInfo: {
          propertyIDType: this.SharedDataService.data.sessionUnitInfo.idSource,
          propertyID: this.SharedDataService.data.sessionUnitInfo.propertyID,
        },
        unitInfo: {
          unitIDType: this.SharedDataService.data.sessionUnitInfo.idSource,
          unitID: '',
        },
        coverageDate:
          this.SharedDataService.data.coverageDate.getFullYear() +
          '/' +
          (this.SharedDataService.data.coverageDate.getMonth() + 1) +
          '/' +
          this.SharedDataService.data.coverageDate.getDate(),
        quoteRequestSource: this.sessionWidgetData.appSource,
        isRenewal: false,
        residentsInfo: this.SharedDataService.data.sessionResidentInfo,
      };

      // Populate the unit ID if it exists
      if (this.SharedDataService.data.sessionUnitInfo.unitID && this.SharedDataService.data.sessionUnitInfo.unitID !== null) {
        this.quoteRequestData.unitInfo.unitID = this.SharedDataService.data.sessionUnitInfo.unitID;
      }

      // Populate the isRenewal if it exists
      if (this.sessionWidgetData.isRenewal) {
        this.quoteRequestData.isRenewal = this.sessionWidgetData.isRenewal;
      }
    }
    // Display environment data
    console.log('ENVIRONMENT DATA:', environment);

    if (!this.sessionWidgetData.quoteID) {
      console.log('QUOTE DATA: ', this.quoteRequestData);
      this.getValidation();
    }
  }

  getValidation() {
    this.AuthenticationService.getAnalyticsId().subscribe(
      (data) => {
        const analyticsCredentials = data.analyticsCode;
        console.log('analyticsCredentials: ', analyticsCredentials);
        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance Widget',
          'Received Analytics Credientials',
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
        this.getAnalyticsToken(analyticsCredentials);
      },
      (err) => {
        /** Google Analytics Event */
        this.SharedDataService.trackEvents(
          'Insurance Widget',
          'Error Getting Analytics Credentials',
          this.SharedDataService.data.insuranceInfo.quoteRequestSource
        );
      }
    );
  }

  ngOnInit() {
    /** Reset Widget Back to Loading Screen */
    this.router.navigate(['/loading'], { skipLocationChange: true });

    /** Include the Telescope Script in the application */
    if (environment.production) {
      const telescopeScript = document.createElement('script') as any;
      telescopeScript.defer = true;
      telescopeScript.src = environment.telescopeTracking;
      telescopeScript.type = 'text/javascript';
      document.getElementsByTagName('head')[0].appendChild(telescopeScript);
    }

    // Create current date
    this.currDate = new Date();

    // Effective Date Limit - 62 days
    this.effectiveDateLimit = new Date();
    this.effectiveDateLimit.setDate(this.currDate.getDate() + 62);

    // Assign property ID for dev testing
    if (!environment.production) {
      this.sampleId = '625658';
      // 625658 - AssetProtect
      // 156
      // 8612 - NH property for bypass initial modal fee
      // 620597 - Third Party Upload (for PV.com)
      // 358638 - AssetProtect
      // 15848 - LA upfront tax
      // 603775 - FL upfront tax
      // 1771-multiple fees
      // 610828
      // 611425-eRenterDirect
      // 621800-AssetProtect (multiple packages)
      // 621804-AssetProtect (one package)
      // 15861-bedbugs
      // 6161-not required
      // 0-invalid
      // 2777, 618204 -show tax
      // 1220 -carrier integrated
      // 14911 -moratorium
      // 2329 -no screening
      // 9815 - special info
      // 619957 - no good/better/best packages
    }

    if (!this.SharedDataService.retrieveStorageValue('sessionStorage', 'rpInsuranceWidget')) {
      // Test
      // Create Mock Widget Settings Variable
      // idSource options include OneSite, Yardi, LeasingDesk
      // appSource options include

      let rpInsuranceWidgetData = {};

      // LeasingDesk Test - Creating New Quote

      rpInsuranceWidgetData = {
        appTheme: {
          borderRadius: '0',
          primaryColor: '12345',
          backgroundColor: '#F9FBFD',
          secondaryColor: '#ee6300',
        },
        appSource: 'OLL Integration',
        isRenewal: false,
        coverageEffDate: '12-4-2004',
        unitInfo: {
          unitID: '',
          propertyID: this.sampleId,
          idSource: 'LeasingDesk',
        },
        residentInfo: [
          {
            resident: {
              firstName: 'Reale',
              middleName: 'Paige',
              lastName: 'Primary',
            },
            dateOfBirth: '',
            externalResID: '9d84b5ff0559af',
            isPrimaryResident: true,
            email: 'tester@realpage.com',
            mobileNumber: '',
          },
          {
            resident: {
              firstName: 'Royale',
              middleName: 'Paige',
              lastName: 'Secondary',
            },
            dateOfBirth: '3-18-2004',
            externalResID: '9d84bff30559ae',
            isPrimaryResident: false,
            email: 'n/a@na.com',
            mobileNumber: '+1 (214) 234-5678',
          },
          {
            resident: {
              firstName: 'Junior',
              middleName: 'Paige',
              lastName: 'Primary Jr.',
            },
            dateOfBirth: '3-18-2004',
            externalResID: '9d814bffZ306559ae',
            isPrimaryResident: false,
            email: 'n/a@na.com',
            mobileNumber: '+1 (214) 234-5678',
          },
          {
            resident: {
              firstName: 'JuniorTwo',
              middleName: 'Paige',
              lastName: 'Primary Jr.',
            },
            dateOfBirth: '3-18-2004',
            externalResID: '9d814bffZ306559ae',
            isPrimaryResident: false,
            email: 'n/a@na.com',
            mobileNumber: '+1 (214) 234-5678',
          },
          {
            resident: {
              firstName: 'JuniorThree',
              middleName: 'Paige',
              lastName: 'Primary Jr.',
            },
            dateOfBirth: '3-18-2004',
            externalResID: '34kjb4kbk6b43k6',
            isPrimaryResident: false,
            email: 'n/a@na.com',
            mobileNumber: '+1 (214) 234-5678',
          },
          {
            resident: {
              firstName: 'JuniorFour',
              middleName: 'Paige',
              lastName: 'Primary Jr.',
            },
            dateOfBirth: '3-18-2004',
            externalResID: '4bt5k43b5k34bk5bk43',
            isPrimaryResident: false,
            email: 'n/a@na.com',
            mobileNumber: '+1 (214) 234-5678',
          },
          {
            resident: {
              firstName: 'JuniorFive',
              middleName: 'Paige',
              lastName: 'Primary Jr.',
            },
            dateOfBirth: '3-18-2004',
            externalResID: 'k5j34k6bk3b6bk',
            isPrimaryResident: false,
            email: 'n/a@na.com',
            mobileNumber: '+1 (214) 234-5678',
          },
        ],
      };

      // LeasingDesk Test - Retrieve Quote
      // Quote ID Options 3400330032003400330038003200, 3400330032003400350034003000, 3400330032003400380037003800
      // Wind/Hail Exemtions 3600340037003400390034003100 DEV, 3600340037003400390034003000 DEV, 3500300031003200340036003200 SAT
      /*
      rpInsuranceWidgetData = {
        appTheme: {
          borderRadius: '0',
          primaryColor: '#0079B3',
          backgroundColor: '#F9FBFD',
          secondaryColor: '#ee6300',
        },
        appSource: 'LeasingDesk Call Center',
        quoteID: '31003300380033003400350031003500',
        residentInfo: [],
      };
      */
      // LeasingDesk Test - Policy Coverage Changes
      /*
      rpInsuranceWidgetData = {
        appTheme: {
          borderRadius: '0',
          primaryColor: '#0079B3',
          backgroundColor: '#F9FBFD',
          secondaryColor: '#ee6300',
        },
        appSource: 'LeasingDesk Call Center',
        policyID: '31003300380033003400350031003500',
        userToken:
          'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTb3VyY2UiOiJBUEkiLCJSb2xlIjoiSW50ZXJuYWwiLCJleHAiOjE2NzI4MDI3NTEsImlzcyI6InVhdC5yZWFscGFnZS5jb20iLCJhdWQiOiJ1YXQucmVhbHBhZ2UuY29tIn0.ddeuFhgXDt7klHgREugc0bvScxiTPd7nwQRBkkf-F1o', // For erp pass usertoken, for LD encrypted userID
      };
      */
      // Save Application Session Variable (FOR MOCK)
      this.SharedDataService.saveStorageValue('sessionStorage', 'rpInsuranceWidget', rpInsuranceWidgetData);
    }

    // Retrieve Widget Data with the proper appended prefix 'rp'
    this.sessionWidgetData = this.SharedDataService.retrieveStorageValue('sessionStorage', 'rpInsuranceWidget');

    /** Transfer Auth Information & Request Source to the Insurance Quote Info Container */
    this.SharedDataService.data.insuranceInfo.authInfo = {
      userId: 'webservice@realpage.com',
      password: 'hgC2HfBd',
    };

    if (this.sessionWidgetData) {
      /** Check the date and reformat if necessary */
      if (this.sessionWidgetData.coverageEffDate) {
        this.SharedDataService.data.thirdPartyEffDate = this.sessionWidgetData.coverageEffDate;
        this.validateCoverageDate(this.sessionWidgetData.coverageEffDate);
      }

      this.SharedDataService.data.insuranceInfo.quoteRequestSource = this.sessionWidgetData.appSource;
      /** Google Analytics Event */
      this.SharedDataService.trackEvents('Insurance Widget', 'Startup', this.SharedDataService.data.insuranceInfo.quoteRequestSource);

      // CSS Override
      if (this.sessionWidgetData.appTheme) {
        // Verify all colors before you use them
        this.validateColorFormats(this.sessionWidgetData.appTheme);
      }

      // Quote ID
      if (this.sessionWidgetData.quoteID) {
        this.SharedDataService.data.retrieveQuoteID = this.sessionWidgetData.quoteID;
      }

      // Policy ID
      if (this.sessionWidgetData.policyID) {
        this.SharedDataService.data.policyID = this.sessionWidgetData.policyID;
        /** Setup Google Analytics with Policy ID */
        this.loadGA(this.SharedDataService.data.policyID);
      }

      // Property Data
      if (this.sessionWidgetData.unitInfo) {
        this.SharedDataService.data.sessionUnitInfo = this.sessionWidgetData.unitInfo;
        /** Address inconsistency in the naming of unitID */
        if (this.SharedDataService.data.sessionUnitInfo.UnitID) {
          this.SharedDataService.data.sessionUnitInfo.unitID = this.SharedDataService.data.sessionUnitInfo.UnitID;
        }
      }
      // Resident Data
      if (this.sessionWidgetData.residentInfo && this.sessionWidgetData.residentInfo.length > 0) {
        this.validateResidentData(this.sessionWidgetData.residentInfo);
      } else {
        this.getValidation();
      }
    } else {
      // Show Error Screen
      this.SharedDataService.data.requestedQuote = true;
      this.SharedDataService.data.receivedQuote = false;
      this.SharedDataService.data.pointOfLease.flow = 'inactive';
      this.router.navigate(['/control-flow'], { skipLocationChange: true });
    }
  }

  ngOnChanges() {
    if (this.SharedDataService.data.noInsurance) {
      console.log('no insurance: ', this.SharedDataService.data.noInsurance);
    }
  }
}
